import { useContext, useState } from 'react'
import { Switch } from '@headlessui/react'
import { injuryOptions } from 'functions/injuryUtils'
import { ModalContext } from '../ModalContext'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function InjuryInputModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const [selectedInjury, setSelectedInjury] = useState((modalData.injuries ?? [])[0] ?? null)

    const HandleInjuryToggle = (injuryKey) => {
        setSelectedInjury((currentInjury) => (currentInjury === injuryKey ? null : injuryKey))
    }

    const OnSaveButton = () => {
        modalData.setInjuries(selectedInjury ? [selectedInjury] : [])
        HideModal()
    }

    return (
        <div className='space-y-4 text-left'>
            <div className='text-center text-xl font-semibold leading-6'>
                Simulated Injury
            </div>

            <p className='text-sm text-gray-500 text-center'>
                Injury overrides apply to every boilerplate program: exercises the injury rules out are skipped and their replacements added
            </p>

            <div className='space-y-3'>
                {injuryOptions.map((injuryOption) => (
                    <div
                        key={injuryOption.key}
                        className='flex items-center justify-between px-4 py-3 rounded-xl bg-gray-100'
                    >
                        <span className='text-gray-700'>{injuryOption.label}</span>

                        <Switch
                            checked={selectedInjury === injuryOption.key}
                            onChange={() => HandleInjuryToggle(injuryOption.key)}
                            data-testid={`injury-toggle-${injuryOption.key}`}
                            className={`
                                relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                                ${selectedInjury === injuryOption.key ? 'bg-orange-400' : 'bg-gray-200'}
                            `}
                        >
                            <span className="sr-only">{injuryOption.label}</span>
                            <span
                                aria-hidden="true"
                                className={`
                                    pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                    ${selectedInjury === injuryOption.key ? 'translate-x-5' : 'translate-x-0'}
                                `}
                            />
                        </Switch>
                    </div>
                ))}
            </div>

            <BrandColorButton
                size='large'
                text='Save'
                action={OnSaveButton}
            />
        </div>
    )
}
